import { VehicleService } from "./../../vehicle/models/vehicle.service";
import {
  VehicleModel,
  VehicleMappingModel
} from "./../../vehicle/models/vehicle.model";
import { SharedVehicleGroupService } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { CompanyService } from "./../../company/models/company.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { SharedVehicleGroupModel } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { CompanyModel } from "./../../company/models/company.model";
import { InstanceModel } from "./../../instance/models/instance.model";
import {
  ReportFilterModel,
  DropdownModel
} from "./../models/report-filter.model";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  ApplicationRouteURL,
  WeGoConfig,
  IKeyValueInterface,
  RoleLevel,
  PermissionType
} from "./../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { VehicleOccupancyService } from "./../models/vehicle-occupancy.service";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { ReportFilterService } from "../models/report-filter.service";
import { CustomerService } from "../../customer/models/customer.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { ContractTypeGroupService } from "../../contracttypegroup/models/contracttypegroup.service";
import { CostCenterReportFilter } from "../models/report-filter-cost-center.model";
import { OrganizationDriverMappingModel } from "../../organizationdriver/models/organization-driver.model";

@Component({
  selector: "wego-report-filter-cost-center",
  template: require('../views/report-filter-cost-center.component.html'),
  providers: [
    InstanceService,
    CompanyService,
    SharedVehicleGroupService,
    VehicleService,
    OrganizationService,
    ReportFilterService,
    ContractTypeGroupService
  ]
})
export class ReportFilterCostCenterComponent implements OnInit {
  @Output("OnSearch") onSearch = new EventEmitter();
  @Output("OnExportPDF") onExportPDF = new EventEmitter();
  @Output("OnExportExcel") onExportExcel = new EventEmitter();
  @Output("ResetValidSearch") resetValidSearch = new EventEmitter();

  @Input("IsValidSearch") isValidSearch: boolean = false;
  @Input("ErrorModel") errorModel: IKeyValueInterface[];
  @Input("ReportName") reportName: string;

  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;

  model: CostCenterReportFilter;
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  contractTypeGroupList: DropdownModel[];
  permissionType: string;
  sharedVehicleGroupList: DropdownModel[];
  vehicleList: DropdownModel[];
  organizationList: DropdownModel[];
  customerList: DropdownModel[];
  apiErrorMsg: string;
  isLoader: boolean;
  roleLevel = RoleLevel;
  searchDriverName: string;
  searchLicenceTag: string;
  searchCostTypeName: string;

  public get vehicleMappingModel(): VehicleMappingModel {
    let vehicleMapping: VehicleMappingModel = new VehicleMappingModel();
    vehicleMapping.companyHashId = this.model.companyHashId;
    vehicleMapping.organizationHashId = this.model.organizationHashId;
    vehicleMapping.customerHashId = this.model.customerHashId;
    vehicleMapping.instanceHashId = this.model.instanceHashId;
    return vehicleMapping;
  }

  public get organizationDriverModel(): OrganizationDriverMappingModel {
    let organizationDriverMapping: OrganizationDriverMappingModel = new OrganizationDriverMappingModel();
    organizationDriverMapping.companyHashId = this.model.companyHashId;
    organizationDriverMapping.organizationHashId = this.model.organizationHashId;
    organizationDriverMapping.customerHashId = this.model.customerHashId;
    organizationDriverMapping.instanceHashId = this.model.instanceHashId;
    return organizationDriverMapping;
  }

  public get isInstanceSelected(): boolean {
    return !!this.model.customerHashId && !!this.model.instanceHashId;
  }

  constructor(
    private customerService: CustomerService,
    private authService: AuthService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private vehicleService: VehicleService,
    private reportFilterService: ReportFilterService,
    private organizationService: OrganizationService,
    private contractTypegroupService: ContractTypeGroupService
  ) {}

  ngOnInit() {
    this.model = new CostCenterReportFilter();
    this.permissionType = PermissionType.VIEW;
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
    this.searchCostTypeName = this.model.searchCostTypeNameList.join();

    this.InitReportFilter();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public InitReportFilter() {
    // this.GetAllInstanceList();
    this.GetCustomerListDropdown();
  }

  public GetCustomerListDropdown() {
    this.customerService.GetDropdownListCustomer(this.reportName).subscribe(
      (res: any) => {
        this.customerList = res.data;

        if (this.customerList != null && this.customerList.length > 0) {
          if (!this.model.customerHashId && this.customerList.length == 1) {
            this.model.customerHashId = this.customerList[0].keyHash;
          }
          this.OnCustomerChange();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetInstanceListDropdown() {
    this.instanceService
      .GetDropdownInstanceList(this.reportName, this.model.customerHashId)
      .subscribe(
        res => {
          this.instanceList = res.data;
          if (this.instanceList && this.instanceList.length > 0) {
            if (!this.model.instanceHashId && this.instanceList.length == 1) {
              this.model.instanceHashId = this.instanceList[0].keyHash;
            }
            this.OnInstanceChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCompanyListByInstance() {
    this.companyService
      .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          if (this.companyList && this.companyList.length > 0) {
            if (!this.model.companyHashId && this.companyList.length == 1) {
              this.model.companyHashId = this.companyList[0].keyHash;
            }
            this.OnCompanyChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCompanyBaseOrganizationDropDown() {
    this.organizationService
      .GetSVGBaseOrganizationDropDown(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyHashId,
        ""
      )
      .subscribe(
        res => {
          this.organizationList = res.data;
          if (this.organizationList && this.organizationList.length > 0) {
            if (
              !this.model.organizationHashId &&
              this.organizationList.length == 1
            ) {
              this.model.organizationHashId = this.organizationList[0].keyHash;
            }
            this.OnOrganizationChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  // Event
  public OnCustomerChange(): any {
    this.model.instanceHashId = "";
    this.instanceList = [];
    this.model.companyHashId = "";
    this.companyList = [];
    this.model.organizationHashId = "";
    this.organizationList = [];
    this.contractTypeGroupList = [];
    //this.model.vehicleHashId = "";
    this.vehicleList = [];
    this.contractTypeGroupList = [];
    this.ResetValidSearch();
    if (this.model.customerHashId) {
      this.GetInstanceListDropdown();
    }
  }

  public OnInstanceChange() {
    this.companyList = null;
    this.sharedVehicleGroupList = null;
    this.vehicleList = null;
    this.organizationList = null;
    this.model.companyHashId = "";
    //this.model.vehicleHashId = "";
    this.model.organizationHashId = "";
    this.isLoader = true;
    this.contractTypeGroupList = null;
    this.ResetValidSearch();
    if (this.model.instanceHashId) {
      this.GetCompanyListByInstance();
    } else {
      this.companyList = [];
      this.sharedVehicleGroupList = [];
      this.vehicleList = [];
      this.organizationList = [];
      this.model.organizationHashId = "";
      this.model.companyHashId = "";
      //this.model.vehicleHashId = "";
      this.contractTypeGroupList = [];
    }
  }

  public OnCompanyChange() {
    this.sharedVehicleGroupList = null;
    this.vehicleList = null;
    this.organizationList = null;
    //this.model.vehicleHashId = "";
    this.model.organizationHashId = "";
    this.isLoader = true;
    this.contractTypeGroupList = null;
    this.ResetValidSearch();
    this.GetCompanyBaseOrganizationDropDown();
    this.sharedVehicleGroupList = [];
    this.vehicleList = [];
    this.organizationList = [];
    this.contractTypeGroupList = [];
    //this.model.vehicleHashId = "";
  }

  public OnOrganizationChange() {
    this.ResetValidSearch();
  }

  public OnVehicleChange() {
    this.ResetValidSearch();
  }

  public OnFromDateChange() {
    this.ResetValidSearch();
  }

  public OnToDateChange() {
    this.ResetValidSearch();
  }

  public ResetValidSearch() {
    this.clearDriverList();
    this.clearVehicleList();
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  // Button Click
  public OnSearch($event: any) {
    this.onSearch.emit({ model: this.model });
  }

  public OnExportPDF($event: any) {
    this.onExportPDF.emit({ model: this.model });
  }

  public OnExportExcel($event: any) {
    this.onExportExcel.emit({ model: this.model });
  }

  public OnSearchChange() {
    this.ResetValidSearch();
  }

  public clearcostType() {
    this.model.searchCostTypeNameList = [];
    this.searchCostTypeName = "";
    this.model.costTypeHashId = "";
    this.model.costTypeHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public clearDriverList() {
    this.model.searchDriverNameList = [];
    this.searchDriverName = "";
    this.model.driverHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public clearVehicleList() {
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = "";
    this.model.vehicleHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }
  public SuccessSelectCostCenterModal($event: any) {
    this.model.searchCostTypeNameList = $event.CostTypeName;
    this.searchCostTypeName = this.model.searchCostTypeNameList.join();
    this.model.costTypeHashIdList = $event.CostTypeHashId;
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectDriverModal($event: any) {
    this.model.searchDriverNameList = $event.DriverName;
    this.searchDriverName = this.model.searchDriverNameList.join();
    this.model.driverHashIdList = $event.DriverHashId;
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectVehicleModal($event: any) {
    this.model.searchLicenceTagList = $event.LicenceTag;
    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.model.vehicleHashIdList = $event.VehicleMasterHashID;
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/report-filter-cost-center.component.ts